import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { useEffect } from "react";
import i18n from "./i18n";

const PAGE_META = {
  home: {
    title: "女友的妈妈影视专区 - 电影电视剧剧情及资讯",
    description:
      "女友的妈妈影视专区提供最新电影电视剧信息、剧情介绍及影视资讯，涵盖多样影视内容，助您全面了解相关视频资源。",
  },
  detail: {
    title: "影视详情 - 女友的妈妈影视专区",
    description: "影视作品完整剧情介绍、演职人员信息与相关资讯推荐。",
  },
  newsDetail: {
    title: "影视资讯 - 女友的妈妈影视专区",
    description: "影视行业最新报道与动态，涵盖定档、幕后与剧情解读。",
  },
  news: {
    title: "影视资讯 - 最新报道与动态",
    description: "女友的妈妈影视专区资讯栏目，追踪相关影视作品的最新动态与深度解读。",
  },
  category: {
    title: "女友的妈妈影视分类 - 电影电视剧列表",
    description: "按类型、地区、年份筛选电影与电视剧，查看剧情简介与相关资讯。",
  },
  search: {
    title: "搜索结果 - 女友的妈妈影视专区",
    description: "站内影视作品与资讯搜索结果，支持按名称、类型与关键词检索。",
  },
  about: {
    title: "关于我们 - 女友的妈妈影视专区",
    description: "了解女友的妈妈影视专区的品牌理念、内容范围与联系方式。",
  },
};

function PageMeta() {
  const location = useLocation();

  useEffect(() => {
    let meta = PAGE_META.home;
    if (location.pathname === "/category") meta = PAGE_META.category;
    else if (location.pathname.startsWith("/detail")) meta = PAGE_META.detail;
    else if (location.pathname === "/news") meta = PAGE_META.news;
    else if (location.pathname.startsWith("/news/detail")) meta = PAGE_META.newsDetail;
    else if (location.pathname === "/search") meta = PAGE_META.search;
    else if (location.pathname === "/about") meta = PAGE_META.about;

    document.title = meta.title;
    const tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", meta.description);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <PageMeta />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;